import clsx from 'clsx';
import Typography from '../Typography';
import React from 'react';

import { CssModuleType } from '@utils/cssModules';

import currentCssModule from './CheckboxWithLabel.module.scss';

interface CheckboxWithLabelProps extends React.PropsWithChildren<any> {
    item: {
        display_name: string;
        value: string;
        count: number;
    };
    facetName?: string;
    isChecked?: boolean;
    onToggle?: Function;
    largeCheckboxes?: boolean;
}

const CheckboxWithLabel: React.FC<CheckboxWithLabelProps> = ({
    item,
    isChecked,
    onToggle,
    facetName,
    largeCheckboxes = false
}) => {
    const st: CssModuleType = currentCssModule;
    const name = item.value.replace(/["\\]/g, '');

    return (
        <label
            htmlFor={facetName ? `${facetName}__${name}` : item.display_name}
            className={st.label}
        >
            <input
                aria-label={item.display_name}
                id={facetName ? `${facetName}__${name}` : item.display_name}
                type='checkbox'
                checked={isChecked}
                onChange={() => {
                    onToggle({
                        value: name,
                        display_name: item.display_name,
                        facet_name: facetName
                    });
                }}
            />
            <Typography
                className={clsx(
                    st['label__text'],
                    largeCheckboxes ? st['label__text--large'] : ''
                )}
            >{`${item.display_name} (${item.count})`}</Typography>
        </label>
    );
};

export default CheckboxWithLabel;
